var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 735 107",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillrule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M526.284 52.709h-61.101v93.272h60.818l-4.372-9.728h-43.6v-31.626h41.876v-9.906h-42.261V63.073h43.775l4.865-10.364Z",
    style: {
      fill: "#fff"
    },
    transform: "translate(208.0991 -52.7093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.597 52.709h-41.159c-9.758 0-25.298 7.99-25.159 26.091.127 16.491 13.614 25.946 24.587 25.65 13.045-.352 15.086.361 22.451.361 7.366 0 14.053 7.193 14.053 14.689 0 8.987-7.555 17.157-18.952 17.157h-40.426l5.42 9.324s24.05.157 37.176 0c13.972-.166 26.901-8.427 26.901-26.562s-14.145-25.31-24.693-25.31h-21.405c-8.231 0-14.775-9.063-14.775-15.675 0-6.58 4.361-15.071 15.418-14.99 11.589.086 35.854-.245 35.854-.245l4.709-10.49Z",
    style: {
      fill: "#fff"
    },
    transform: "translate(-59.1619 -52.7093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.597 52.709h-41.159c-9.758 0-25.298 7.99-25.159 26.091.127 16.491 13.614 25.946 24.587 25.65 13.045-.352 15.086.361 22.451.361 7.366 0 14.053 7.193 14.053 14.689 0 8.987-7.555 17.157-18.952 17.157h-40.426l5.42 9.324s24.05.157 37.176 0c13.972-.166 26.901-8.427 26.901-26.562s-14.145-25.31-24.693-25.31h-21.405c-8.231 0-14.775-9.063-14.775-15.675 0-6.58 4.361-15.071 15.418-14.99 11.589.086 35.854-.245 35.854-.245l4.709-10.49Z",
    style: {
      fill: "#fff"
    },
    transform: "translate(209.0551 -52.7093)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.556 52.709v93.272h11.112V71.273l57.499 74.708h12.013V52.709h-11.831v74.215l-56.684-74.215h-12.109ZM59.162 52.709l7.624 16.535 94.478-6.096 5.279-10.41-107.381-.029ZM155.737 74.198l-19.05 5.957-32.05 63.361 8.215 15.747 42.885-85.065ZM186.518 52.709l-4.629 10.509h34.338v82.763h12.696v-82.58h30.429V52.709h-72.834ZM278.226 52.709v93.272h12.364V104.26h55.075v41.721h12.611V52.709h-12.615v41.587h-55.005V52.709h-12.43ZM526.284 52.709h-61.101v93.272h60.818l-4.372-9.728h-43.6v-31.626h41.876v-9.906h-42.261V63.073h43.775l4.865-10.364Z",
    style: {
      fill: "#fff"
    },
    transform: "translate(-59.1619 -52.7093)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.71e856d8b8d8945263ce32e86cbf1ae4.svg";
export { ForwardRef as ReactComponent };